import { Component, OnInit } from '@angular/core';
import { ConsultaService } from '../../services/consulta.service';
import { ResportesAdminService } from '../../services/resportes-admin.service';
import { Router } from '@angular/router';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { URL_IMG } from '../../../conf/url.servicios';
import { ActivatedRoute } from '@angular/router';

import { DatePickerModule } from 'ng2-datepicker-bootstrap';


import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';

declare var jquery: any;
declare var $: any;
declare var bootbox: any;
@Component({
  selector: 'app-reporte-ventas',
  templateUrl: './reporte-ventas.component.html',
  styleUrls: ['./reporte-ventas.component.css']
})
export class ReporteVentasComponent implements OnInit {
  date: any;
  ventas: any = [];
  constructor(private router: Router, private fb: FormBuilder, private consultaService: ConsultaService,
    private resportesAdminService: ResportesAdminService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
  }

  buscarVentas() {
    alert('Busca Ventas');
  }

  clickExcel() {
    const ws_name = 'SomeSheet';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(this.ventas);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, {
      bookType: 'xlsx', bookSST: true, type:
        'binary'
    });

    function s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
      };
      return buf;
    }

    saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), 'exported.xlsx');
  }
}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/components/reporte-ventas/reporte-ventas.component.ts